import Base from "../../../base";
import SimListLayout from "../layout";

export default class SimChooseList extends Base
{
    render() {
        return (
            <SimListLayout
                search={{
                    status:0,
                    company_id:this.app.getUrlParams('companyId')
                }}
                searchShow={false}
                hidden={['proddedAt']}
                canCheck={true}
                btnShow={false}
                oprationShow={false}
            />
        );
    }
}
